module.exports = __webpack_public_path__ + "static/img/3.afe5520.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/3.png
// module id = xqQg
// module chunks = 0